import { supabase } from '../supabase'

export type ConsentPrefs = {
  essential: true      // always true, cannot be changed
  analytics: boolean
  attribution: boolean
  timestamp: string
}

export async function saveConsent(prefs: Omit<ConsentPrefs, 'essential'>) {
  const consent: ConsentPrefs = {
    essential: true,
    analytics: prefs.analytics,
    attribution: prefs.attribution,
    timestamp: new Date().toISOString()
  }
  
  // Save locally for immediate reading
  localStorage.setItem('mf_cookie_consent', JSON.stringify(consent))
  
  // Also persist to DB if user is logged in
  const { data: { session } } = await supabase.auth.getSession()
  if (session?.user) {
    await supabase.from('profiles')
      .update({ 
        cookie_consent: consent,
        cookie_consent_at: new Date().toISOString()
      })
      .eq('id', session.user.id)
  }
}

export function getConsent(): ConsentPrefs | null {
  const raw = localStorage.getItem('mf_cookie_consent')
  return raw ? JSON.parse(raw) : null
}

export function hasConsented(): boolean {
  return getConsent() !== null
}
